export default "__VITE_ASSET__DQHPL1VG__"